import Cookies from "js-cookie";
import {
  COURSE_FOLDER_CREATE_URL,
  SUBJECT_FOLDER_CREATE_URL,
  TOPIC_FOLDER_CREATE_URL,
  SUBTOPIC_FOLDER_CREATE_URL,
  GET_FOLDER_URL,
  GET_QUESTION_BANKS_URL,
  CREATE_QUESTION_BANK_URL,
  GET_ONE_QUETION_BANK_URL,
  UPDATE_QUESTION_BANK_URL,
  UPDATE_FOLDER_URL,
  DELETE_FOLDER_URL,
  GET_ADMIN_QUESTION_BANKS_IN_INSTITUTION,
  GET_ADMIN_SINGLE_QUESTION_BANK_IN_INSTITUTION,
  GET_ADMIN_QUESTION_BANKS_FOLDERS_IN_INSTITUTION,
  CREATE_QUESTION_BANK_FOLDER_INSTITUTION,
  UPDATE_QUESTION_BANK_FOLDER_INSTITUTION,
  DELETE_QUESTION_BANK_FOLDER_INSTITUTION,
  GET_ALL_QUESTION_BANK_FOLDERS_INSTITUITION,
  CREATE_QUESTION_BANK_INSTITUTION,
  UPDATE_QUESTION_BANK_INSTITUTION,
  DELETE_QUESTION_BANK_INSTITUTION,
  GET_QUESTION_BANKS_INSTITUTION,
  GET_QUESTION_BANK_INSTITUTION,
} from "../apiurls/apiurls";

const isInstitutionRole = () => {
  const role = Cookies.get("role");
  return role === "institution" || role === "teacher";
};

const getAuthToken = () => {
  if (isInstitutionRole()) {
    return Cookies.get("institution_token");
  }
  return Cookies.get("admin_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};


const getInstitutionAuthToken = () => {
  return Cookies.get("institution_token");
};

const getInstitutionHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getInstitutionAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const createCourseFolder = async (title, key, name) => {
  try {
    const isInstitution = isInstitutionRole();
    const url = isInstitution
      ? CREATE_QUESTION_BANK_FOLDER_INSTITUTION
      : COURSE_FOLDER_CREATE_URL;
    const headers = isInstitution ? getInstitutionHeaders() : getHeaders();

    const body = {
      title,
      key,
      name,
    };

    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating course folder:", error);
    throw error;
  }
};

export const createSubjectFolder = async (title, key, name) => {
  try {
    const isInstitution = isInstitutionRole();
    const url = isInstitution
      ? CREATE_QUESTION_BANK_FOLDER_INSTITUTION
      : SUBJECT_FOLDER_CREATE_URL;
    const headers = isInstitution ? getInstitutionHeaders() : getHeaders();

    const body = {
      title,
      key,
      name,
    };

    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating subject folder:", error);
    throw error;
  }
};

export const createTopicFolder = async (title, key, name) => {
  try {
    const isInstitution = isInstitutionRole();
    const url = isInstitution
      ? CREATE_QUESTION_BANK_FOLDER_INSTITUTION
      : TOPIC_FOLDER_CREATE_URL;
    const headers = isInstitution ? getInstitutionHeaders() : getHeaders();

    const body = {
      title,
      key,
      name,
    };

    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating topic folder:", error);
    throw error;
  }
};

export const createSubtopicFolder = async (title, key, name) => {
  try {
    const isInstitution = isInstitutionRole();
    const url = isInstitution
      ? CREATE_QUESTION_BANK_FOLDER_INSTITUTION
      : SUBTOPIC_FOLDER_CREATE_URL;
    const headers = isInstitution ? getInstitutionHeaders() : getHeaders();

    const body = {
      title,
      key,
      name,
    };

    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating subtopic folder:", error);
    throw error;
  }
};

export const getFolders = async (title, key) => {
  try {
    const params = new URLSearchParams();
    if (title) params.append("title", title);
    if (key) params.append("key", key);

    let baseUrl;
    let headers;

    if (isInstitutionRole()) {
      baseUrl = GET_ALL_QUESTION_BANK_FOLDERS_INSTITUITION;
      headers = getInstitutionHeaders();
    } else {
      baseUrl = GET_FOLDER_URL;
      headers = getHeaders();
    }

    const response = await fetch(`${baseUrl}?${params.toString()}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && data.data) {
      return Array.isArray(data.data) ? data.data : [data.data];
    }
    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching folders:", error);
    throw error;
  }
};

export const getQuestionBanks = async (folderId) => {
  try {
    const params = new URLSearchParams();
    if (folderId) params.append("questionbank_folders", folderId);

    const baseUrl = isInstitutionRole()
      ? GET_QUESTION_BANKS_INSTITUTION
      : GET_QUESTION_BANKS_URL;
    const headers = isInstitutionRole()
      ? getInstitutionHeaders()
      : getHeaders();

    const response = await fetch(`${baseUrl}?${params.toString()}`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && Array.isArray(data.data)) {
      return data.data;
    }

    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching question banks:", error);
    throw error;
  }
};

export const createQuestionBank = async (name, publish, content, folderId) => {
  try {
    const response = await fetch(CREATE_QUESTION_BANK_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({
        name,
        publish,
        content,
        ...(folderId && { questionbank_folders: folderId }),
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating question bank:", error);
    throw error;
  }
};

export const getQuestionBankById = async (id) => {
  try {
    const params = new URLSearchParams();
    if (id) params.append("id", id);

    const response = await fetch(
      `${GET_ONE_QUETION_BANK_URL}?${params.toString()}`,
      {
        method: "GET",
        headers: getHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching question bank by id:", error);
    throw error;
  }
};

export const updateQuestionBank = async (questionBank) => {
  try {
    const { id, name, duration, publish, content } = questionBank || {};
    if (!id) {
      throw new Error("Question bank id is required for update");
    }

    const params = new URLSearchParams();
    params.append("id", id);

    const response = await fetch(
      `${UPDATE_QUESTION_BANK_URL}?${params.toString()}`,
      {
        method: "PUT",
        headers: getHeaders(),
        body: JSON.stringify({
          id,
          name,
          duration,
          publish,
          content,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating question bank:", error);
    throw error;
  }
};


export const getInstitutionQuestionBankFolders = async () => {
  try {
    const response = await fetch(
      GET_ADMIN_QUESTION_BANKS_FOLDERS_IN_INSTITUTION,
      {
        method: "GET",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && Array.isArray(data.data)) {
      return data.data;
    }

    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching institution question bank folders:", error);
    throw error;
  }
};

export const getAllInstitutionQuestionBankFolders = async () => {
  try {
    const response = await fetch(GET_ALL_QUESTION_BANK_FOLDERS_INSTITUITION, {
      method: "GET",
      headers: getInstitutionHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && Array.isArray(data.data)) {
      return data.data;
    }

    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error(
      "Error fetching all institution question bank folders:",
      error
    );
    throw error;
  }
};

export const createInstitutionQuestionBankFolder = async (payload) => {
  const { name, courseKey } = payload || {};
  try {
    const response = await fetch(CREATE_QUESTION_BANK_FOLDER_INSTITUTION, {
      method: "POST",
      headers: getInstitutionHeaders(),
      body: JSON.stringify({
        name,
        course_key: courseKey,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating institution question bank folder:", error);
    throw error;
  }
};

export const updateInstitutionQuestionBankFolder = async (payload) => {
  const { id, ...rest } = payload || {};
  if (!id) {
    throw new Error("Folder id is required for update");
  }

  try {
    const params = new URLSearchParams();
    params.append("id", id);

    const response = await fetch(
      `${UPDATE_QUESTION_BANK_FOLDER_INSTITUTION}?${params.toString()}`,
      {
        method: "PUT",
        headers: getInstitutionHeaders(),
        body: JSON.stringify(rest),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating institution question bank folder:", error);
    throw error;
  }
};

export const deleteInstitutionQuestionBankFolder = async (id) => {
  if (!id) {
    throw new Error("Folder id is required for delete");
  }

  try {
    const params = new URLSearchParams();
    params.append("id", id);

    const response = await fetch(
      `${DELETE_QUESTION_BANK_FOLDER_INSTITUTION}?${params.toString()}`,
      {
        method: "DELETE",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting institution question bank folder:", error);
    throw error;
  }
};

export const getInstitutionQuestionBanks = async (folderId) => {
  try {
    const params = new URLSearchParams();
    if (folderId) params.append("questionbank_folders", folderId);

    const response = await fetch(
      `${GET_QUESTION_BANKS_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && Array.isArray(data.data)) {
      return data.data;
    }

    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching institution question banks:", error);
    throw error;
  }
};

export const getInstitutionQuestionBankById = async (id) => {
  try {
    const params = new URLSearchParams();
    if (id) params.append("id", id);

    const response = await fetch(
      `${GET_QUESTION_BANK_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching institution question bank by id:", error);
    throw error;
  }
};

export const createInstitutionQuestionBank = async (
  name,
  publish,
  content,
  folderId
) => {
  try {
    const response = await fetch(CREATE_QUESTION_BANK_INSTITUTION, {
      method: "POST",
      headers: getInstitutionHeaders(),
      body: JSON.stringify({
        name,
        publish,
        content,
        ...(folderId && { questionbank_folders: folderId }),
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error creating institution question bank:", error);
    throw error;
  }
};

export const updateInstitutionQuestionBank = async (questionBank) => {
  try {
    const { id, name, duration, publish, content } = questionBank || {};
    if (!id) {
      throw new Error("Question bank id is required for update");
    }

    const params = new URLSearchParams();
    params.append("id", id);

    const response = await fetch(
      `${UPDATE_QUESTION_BANK_INSTITUTION}?${params.toString()}`,
      {
        method: "PUT",
        headers: getInstitutionHeaders(),
        body: JSON.stringify({
          id,
          name,
          duration,
          publish,
          content,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating institution question bank:", error);
    throw error;
  }
};

export const deleteInstitutionQuestionBank = async (id) => {
  if (!id) {
    throw new Error("Question bank id is required for delete");
  }

  try {
    const params = new URLSearchParams();
    params.append("id", id);

    const response = await fetch(
      `${DELETE_QUESTION_BANK_INSTITUTION}?${params.toString()}`,
      {
        method: "DELETE",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting institution question bank:", error);
    throw error;
  }
};

export const updateFolder = async (id, name) => {
  try {
    if (!id) {
      throw new Error("Folder id is required for update");
    }

    const params = new URLSearchParams();
    params.append("id", id);

    const response = await fetch(`${UPDATE_FOLDER_URL}?${params.toString()}`, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify({ name }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error updating folder:", error);
    throw error;
  }
};

export const deleteFolder = async (id) => {
  try {
    if (!id) {
      throw new Error("Folder id is required for delete");
    }

    const params = new URLSearchParams();
    params.append("id", id);

    const response = await fetch(`${DELETE_FOLDER_URL}?${params.toString()}`, {
      method: "DELETE",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error deleting folder:", error);
    throw error;
  }
};

export const getAdminQuestionBankFoldersInInstitution = async (title, key) => {
  try {
    const params = new URLSearchParams();
    if (title) params.append("title", title);
    if (key) params.append("key", key);

    const response = await fetch(
      `${GET_ADMIN_QUESTION_BANKS_FOLDERS_IN_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && Array.isArray(data.data)) {
      return data.data;
    }

    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching admin question bank folders in institution:", error);
    throw error;
  }
};

export const getAdminQuestionBanksInInstitution = async (folderId) => {
  try {
    const params = new URLSearchParams();
    if (folderId) params.append("questionbank_folders", folderId);

    const response = await fetch(
      `${GET_ADMIN_QUESTION_BANKS_IN_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (data && Array.isArray(data.data)) {
      return data.data;
    }

    return Array.isArray(data) ? data : data ? [data] : [];
  } catch (error) {
    console.error("Error fetching admin question banks in institution:", error);
    throw error;
  }
};

export const getAdminQuestionBankByIdInInstitution = async (id) => {
  try {
    const params = new URLSearchParams();
    if (id) params.append("id", id);

    const response = await fetch(
      `${GET_ADMIN_SINGLE_QUESTION_BANK_IN_INSTITUTION}?${params.toString()}`,
      {
        method: "GET",
        headers: getInstitutionHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching admin question bank by id in institution:", error);
    throw error;
  }
};

